// calling window dimensions
export const CALL_WINDOW_WIDTH_PX = '351px';
export const CALL_WINDOW_HEIGHT_PX = '601px';
export const CALL_WINDOW_WIDTH_WITHOUT_PX = '351';
export const CALL_WINDOW_HEIGHT_WITHOUT_PX = '601';

// calling remote redesign dimensions
export const CALL_REMOTE_REDESIGN_WIDTH_PX = '350px';
export const CALL_REMOTE_REDESIGN_HEIGHT_PX = '600px';